import { render, staticRenderFns } from "./EnsinoStep2.vue?vue&type=template&id=a5065314&scoped=true&"
import script from "./EnsinoStep2.vue?vue&type=script&lang=js&"
export * from "./EnsinoStep2.vue?vue&type=script&lang=js&"
import style0 from "./EnsinoStep2.vue?vue&type=style&index=0&id=a5065314&prod&scoped=true&lang=css&"
import style1 from "./EnsinoStep2.vue?vue&type=style&index=1&id=a5065314&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5065314",
  null
  
)

export default component.exports